import { ApiHeaders } from '@core/core.types';
import { Result } from '../types/result.types';
import { ResultsFilter } from './results.state';

export class GetResultsListAction {
  static type = '[Results] GetResultsListAction';
  constructor(
    public filters: ResultsFilter,
    public headers: ApiHeaders,
    public pageToLoad: number,
    public reload: boolean
  ) {}
}

export class GetResultAction {
  static type = '[Results] GetResultAction';
  constructor(public resultId: string) {}
}

export class ArchiveResultAction {
  static type = '[Results] ArchiveResultsAction';

  constructor(
    public resultId: string,
    public reason: string
  ) {}
}

export class DeleteResultAction {
  static type = '[Results] DeleteResultAction';

  constructor(public resultId: string) {}
}

export class ListXlsVersionsAction {
  static type = '[Results] ListXlsVersionsAction';

  constructor() {}
}

export class GenerateReportAction {
  static type = '[Results] GenerateReportAction';

  constructor(
    public resultId: string,
    public generationId: string
  ) {}
}

export class ResetResultsPagesAction {
  static type = '[Results] ResetResultsPagesAction';

  constructor() {}
}

export class SetResultsAction {
  static type = '[Results] SetResultsAction';

  constructor(public results: Result[]) {}
}
